import axios from "axios";

const HEADERS = {
  "Content-Type": "application/json",
  Accept: "*/*",
  "X-XSS-Protection": "1",
};

const rmlApi = axios.create({
  baseURL: process.env.REACT_APP_BASE_URL,
  withCredentials: true,
});

export { HEADERS, rmlApi };
